export function withEditableVoids(editor) {
	const {isVoid} = editor;

	editor.isVoid = (element) => {
		return element.type === 'editable-void' ? true : isVoid(element);
	};

	return editor;
}
